<div *ngIf="notificationsSettings" class="scrollable-content">
  <div class="modal-header">
    <h2 mat-dialog-title>{{notificationsSettings.title}}</h2>
  
    <button class="no-style close-btn" mat-dialog-close>
      <mat-icon [svgIcon]="'close'" class="square-icon close-icon" aria-label="close"></mat-icon>
    </button>
  </div>
  <div class="no-result" *ngIf="notifications?.length === 0">
    <h2>{{notificationsSettings.noResult}}</h2>
  </div>
  <mat-dialog-content *ngIf="notifications.length > 0" class="notifications-list" #notificationContent>
    <app-notification *ngFor="let notification of notifications" [data]="notification" [disabled]="notification.disabled" [settings]="notificationsSettings"/>
  </mat-dialog-content>
</div>